import * as React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { styled } from '@mui/material/styles'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid' // Changed to stable Grid

export default function SimpleContainer() {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
  }))

  return (
    <React.Fragment>
      <CssBaseline />
      <Container
        maxWidth='xl'
        sx={{
          bgcolor: '#cfe8fc',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Box sx={{ flexGrow: 1, maxWidth: '100%', padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              {' '}
              {/* Added 'item' prop */}
              <Item>xs=8</Item>
            </Grid>
            <Grid item xs={4}>
              {' '}
              {/* Added 'item' prop */}
              <Item>xs=4</Item>
            </Grid>
            <Grid item xs={4}>
              {' '}
              {/* Added 'item' prop */}
              <Item>xs=4</Item>
            </Grid>
            <Grid item xs={8}>
              {' '}
              {/* Added 'item' prop */}
              <Item>xs=8</Item>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </React.Fragment>
  )
}
